import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

export const SkeletonLoader = ({...props}) => {
	return <Skeleton 
			{...props} />
}